<template>
  <TutorialView
    :cards="cards"
    game="search"
    title="GAME.HOW_TO_SEARCH"
    @play="play()"
  />
</template>

<script>
import TutorialView from '@/components/games/tutorial/TutorialView.vue';

export default {
  name: 'SearchTutorial',
  components: {
    TutorialView,
  },
  data: () => ({
    cards: [
      {
        text: 'SEARCH.TUTORIAL.CHECK',
      },
      {
        text: 'SEARCH.TUTORIAL.SEARCH',
      },
    ],
  }),
  methods: {
    play() {
      this.$store.dispatch('settings/store', { preEvaluatedSearch: true });
    },
  },
  // created() {
  //   // Add pre-form
  //   this.cards.push({
  //     text: 'SEARCH.TUTORIAL.BEFORE_STARTING',
  //     form: this.$store.getters['evaluate/byScreen']('search'),
  //   });
  // },
};
</script>
